import { render } from "./presenters.vue?vue&type=template&id=624b691e&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=624b691e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-624b691e"

export default script